import useJwt from '@/auth/jwt/useJwt'
import { currentRoute } from '../router/index'
import pathToRedirectByUser from '@/store/global/pathToRedirectByUser'
import store from '@/store'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return !!localStorage.getItem('userData') && !!localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/////////////////////////////////////////////////////////////////////////
/////////////////Reglas para redireccionar///////////////////////////////
/////////////////////////////////////////////////////////////////////////

// Definir las rutas como constantes
const MARKETCENTER_DELIVERIES_ROUTE = { name: 'marketcenter-deliveries' }
const DEFAULT_LOGIN_ROUTE = { name: 'auth-login' }

// Fix solo para walmart
const PROFILES_WALMART = {
  3: 'contact_center'
}

// Regla: Redirección por ruta antigua de platform.enviame.io
const useRedirectToPath = () => {
  if (currentRoute.name === 'auth-token' && !!currentRoute.query?.currentRoute && currentRoute?.hash !== '#/create' && currentRoute.query?.currentRoute !== 'login') {
    return { path: currentRoute.query.currentRoute + (currentRoute.hash || '') } || null
  }
}

// Regla: Redirigir si el usuario llega desde las integraciones de Peces
const integrationToIntegrationsRule = () => {
  const redirect_url = sessionStorage.getItem('redirect_url')
  return redirect_url ?? null
}

// Regla: Redirigir si es usuario Freemium (company_category_id === 2)
const userFreemiumRule = ({ userData }) => {
  const isUserFreemium = userData?.legacy_data?.employee?.company?.company_category_id === 2
  return isUserFreemium ? MARKETCENTER_DELIVERIES_ROUTE : null
}

// Regla: Redirigir según el rol del usuario
const userRoleRule = ({ userRole }) => {
  return { name: pathToRedirectByUser[userRole] } || null
}

// Ultima Regla: Redirigir según el profile del usuario
const userProfileRule = () => {
  const profile = store.getters.getProfilesView
  return { name: profile?.redirect_url } || null
}

// Función principal para aplicar reglas
const getTargetRoute = (userRole, userData) => {
  // Definir las reglas de redirección en orden de prioridad
  const rules = [useRedirectToPath, integrationToIntegrationsRule, userFreemiumRule, userRoleRule]

  // Iterar sobre las reglas y retornar la primera ruta válida que se encuentre
  for (const rule of rules) {
    const route = rule({ userData, userRole })
    if (route) return route
  }

  // Si no se cumple ninguna regla, retornar la ruta de login por defecto
  return DEFAULT_LOGIN_ROUTE
}

// Función principal refactorizada
export const getHomeRouteForLoggedInUser = (userRole, currentRoute, userData) => {
  // Fix solo para walmart
  const resolvedRoleOrProfileWalmart = PROFILES_WALMART[userData?.legacy_data?.profile] || userRole

  const targetRoute = getTargetRoute(resolvedRoleOrProfileWalmart, userData)

  // Verificar si la ruta actual ya es la ruta de destino
  const isAlreadyOnTargetRoute = currentRoute?.name === targetRoute.name
  if (isAlreadyOnTargetRoute) {
    return null
  }

  return targetRoute
}
